import { render, staticRenderFns } from "./deftersil.vue?vue&type=template&id=88d104ba&"
import script from "./deftersil.vue?vue&type=script&lang=js&"
export * from "./deftersil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports